import axios, { AxiosRequestConfig } from "axios"
import CONFIG from "./config"
import qs from 'qs'
import { DefaultApi } from "@/generated/openapi/index"

const baseOptions: AxiosRequestConfig = {
  baseURL: CONFIG.baseApiUrl,
  paramsSerializer: params => {
    console.debug('serializing', params)
    return qs.stringify(params, { indices: false, skipNulls: true })
  },
  headers: {
    "X-Requested-With": "XMLHttpRequest"
  }
}

const httpClient = axios.create(baseOptions)

interface OpenApi extends DefaultApi { }
const openApi = new DefaultApi(undefined, '', httpClient)

const createErrorHandler = function<T>(fallbackValue: T): (err: any) => T {
  return (err) => {
    if (err && err.response) {
      console.warn(`HTTP request failed with status code '${err.response.status}', using fallback value '${fallbackValue}'. `)
    } else {
      console.warn(`HTTP request failed due to network error, using fallback value '${fallbackValue}'.`)
    }
    return fallbackValue;
  }
}

export {
  baseOptions,
  httpClient,
  openApi,
  OpenApi,
  createErrorHandler
};
